import gql from "graphql-tag";
import { taskServiceTypeDef } from "../definitions/task-service-type-def";
import { errorsTypeDef } from "../../errors/errors-type-def";

const approveTaskMutation = gql`
  mutation approveTask(
  $taskId: String!
  ){
    task{
      approve(input: {
        id: $taskId
      }){
        output {
          ${taskServiceTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }

  }
`;

export default approveTaskMutation;
